<template>
  <v-card class="py-3" elevation="5" :elevation="is_dialog ? 0 : 5">
    <title-card v-if="!is_dialog" 
                :text="axis ? `Avance en ${axis.nombre_corto}`
                  : `Índice de Igualdad de Género ${ies && ies.siglas || 'IES México'}`"/>
    <div  style="font-size:12px;"
          :id="`ies-gauge-${is_dialog? is_dialog :'main'}`"
          class="mt-3"/>
  </v-card>
</template>

<script>

import * as d3 from 'd3';
import * as d3Array from 'd3-array';
import homeMixin from "../homeMixin";
import chartsMixin from "../chartsMixin";
import TitleCard from "../common/TitleCard";

export default {
  name: 'GaugeChart',
  components: {
    TitleCard,
  },
  mixins: [homeMixin, chartsMixin],
  props:{
    value:{
      type: Number,
      required: false,
      default: 0,
    },
    ies:{
      type: Object,
      required: false,
    },
    axis:{
      type: Object,
      required: false,
    },
    period:{
      type: Object,
      required: false,
    },
    is_dialog:{
      type: Number,
      required: false,
      default: 0,
    },
  },
  data(){
    return {
      config: {
        size              : 820,
        clipWidth         : 200,
        clipHeight          : 110,
        ringInset         : 20,
        ringWidth         : 20,
        
        pointerWidth        : 10,
        pointerTailLength     : 5,
        pointerHeadLengthPercent  : 0.9,
        
        minValue          : 0,
        maxValue          : 10,
        
        minAngle          : -90,
        maxAngle          : 90,
        
        transitionMs        : 750,
        
        majorTicks          : 5,
        labelFormat         : d3.format('d'),
        labelInset          : 10,
        
      },
    }
  },
  computed:{
    gaugeChart(){
      return this.gauge(`#ies-gauge-${this.is_dialog||'main'}`, {
          size: 300,
          clipWidth: 300,
          clipHeight: 200,
          ringWidth: 30,
          maxValue: 5,
          transitionMs: 4000,
        }, this.value)
    },
    elem_id(){
      return `${this.ies && this.ies.id || ''}-${
        this.axis && this.axis.id || '0'}-${
          this.period && this.period.year || '-'}`
    },
  },
  created(){
    this.buildChart()
  },
  updated(){
    this.buildChart()
  },  
  watch: {
    /*value(){
      console.log("watch value")
      //this.updateChart()
    },*/
    elem_id(){
      this.updateChart()
    }
  },
  methods: {
    updateChart(){
      this.buildChart()
    },
    buildChart(){
      this.$nextTick( () =>{
        //console.log("buildChart")
        this.gaugeChart.render(this.value)
        //this.gaugeChart2(2.34, data[1].items);
      })
    },
    gauge(container, configuration, data){
      //console.log(this.category)
      
      var vm = this
      var that = {};
      var range = undefined;
      var r = undefined;
      var pointerHeadLength = undefined;
      var value = 0;
      
      var color = vm.axis ? vm.axis.color : vm.color_idx
      var arcColorFn = this.colorPallete(vm.axis ? vm.axis : null)
      var svg = undefined;
      var arc = undefined;
      var arcs = undefined;
      var scale = undefined;
      var ticks = undefined;
      var tickData = undefined;
      var pointer = undefined;

      var donut = d3.pie();
      
      function deg2rad(deg) {
        return deg * Math.PI / 180;
      }
      
      function newAngle(d) {
        var ratio = scale(d);
        var newAngle = vm.config.minAngle + (ratio * range);
        return newAngle;
      }
      
      function configure(configuration) {
        var prop = undefined;
        for ( prop in configuration ) {
          vm.config[prop] = configuration[prop];
        }
        
        range = vm.config.maxAngle - vm.config.minAngle;
        r = vm.config.size / 2;
        pointerHeadLength = Math.round(r * vm.config.pointerHeadLengthPercent);

        // a linear scale that maps domain values to a percent from 0..1
        scale = d3.scaleLinear()
          .range([0,1])
          .domain([vm.config.minValue, vm.config.maxValue]);
          
        ticks = scale.ticks(vm.config.majorTicks);
        tickData = d3.range(vm.config.majorTicks).map(function() 
          {return 1/vm.config.majorTicks;});
        
        arc = d3.arc()
          .innerRadius(r - vm.config.ringWidth - vm.config.ringInset)
          .outerRadius(r - vm.config.ringInset)
          .startAngle(function(d, i) {
            var ratio = d * i;
            return deg2rad(vm.config.minAngle + (ratio * range));
          })
          .endAngle(function(d, i) {
            var ratio = d * (i+1);
            return deg2rad(vm.config.minAngle + (ratio * range));
          });
      }
      that.configure = configure;
      
      function centerTranslation() {
        return 'translate('+r +','+ r +')';
      }
      
      function isRendered() {
        return (svg !== undefined);
      }
      that.isRendered = isRendered;
      
      function render(newValue) {
        //console.log(container)
        d3.selectAll(container + " > *").remove();
        svg = d3.select(container)
          .append('svg:svg')
            .attr('class', 'gauge')
            .attr('id', vm.is_dialog ? `dial_gauge${vm.is_dialog}` : 'main_gauge')
            //.attr('width', vm.config.clipWidth)
            //.attr('height', vm.config.clipHeight + 70);
            .attr("viewBox", [-10, -10, 
                vm.config.clipWidth+20 , 
                vm.config.clipHeight+20])

        
        var centerTx = centerTranslation();
        
        arcs = svg.append('g')
            .attr('class', 'arc')
            .attr('transform', centerTx);
        
        //console.log(tickData)
        arcs.selectAll('path')
            .data(tickData)
          .enter().append('path')
            .attr('fill', function(d, i) {
              return arcColorFn(d * i);
            })
            .attr('d', arc);
        
        var lg = svg.append('g')
            .attr('class', 'label')
            .attr('transform', centerTx);
        lg.selectAll('text')
            .data(ticks)
          .enter().append('text')
            .attr('transform', function(d) {
              var ratio = scale(d);
              var newAngle = vm.config.minAngle + (ratio * range);
              return 'rotate(' +newAngle +') translate(0,' +(vm.config.labelInset - r) +')';
            })
            .text(vm.config.labelFormat);

        var lineData = [ [vm.config.pointerWidth / 2, 0], 
                [0, -pointerHeadLength],
                [-(vm.config.pointerWidth / 2), 0],
                [0, vm.config.pointerTailLength],
                [vm.config.pointerWidth / 2, 0] ];
        var pointerLine = d3.line().curve(d3.curveLinear)
        
        svg.append('text')
          .attr('x', vm.config.clipWidth/2)
          .attr('y', vm.config.clipHeight )
          .text(`${vm.format_perc(newValue, 1)} de 5`)
          .style('font-weight', 'bold')
          .style('fill', color)
          .style("font-size",40)
          .attr("text-anchor", "middle")

        /*svg.append('text')
          .attr('x', vm.config.clipWidth/2)
          .attr('y', vm.config.clipHeight + 65)
          .text("Índice de igualdad de género en IES")
          .style("font-size",17)
          .style("fill","grey")
          .attr("text-anchor", "middle")*/

        var pg = svg.append('g').data([lineData])
            .attr('class', 'pointer')
            .attr('transform', centerTx);
            
        pointer = pg.append('path')
          .attr('id', 'pointer-path')
          .attr('d', pointerLine/*function(d) { return pointerLine(d) +'Z';}*/ )
          .attr('transform', 'rotate(' + (2.5 / vm.config.maxValue) * 180 + ')');
          
        update(newValue === undefined ? 0 : newValue);
      }
      
      that.render = render;

      function update(newValue, newConfiguration) {
        if ( newConfiguration  !== undefined) {
          configure(newConfiguration);
        }
        var ratio = scale(newValue);
        var newAngle = vm.config.minAngle + (ratio * range);

        pointer.transition()
          .duration(vm.config.transitionMs)
          .ease(d3.easeElastic)
          .attr('transform', 'rotate(' +newAngle +')');

        arcs.transition()
          .duration(vm.config.transitionMs)
          .ease(d3.easeElastic)
          .attr('fill', (d, i) => arcColorFn(d * i))
      }
      that.update = update;

      configure(configuration);
      
      return that;
    },
  },
}
</script>

<style lang="scss" scoped>
  #ies-gauge g.arc {
    fill: steelblue;
  }

  #ies-gauge g.pointer {
    fill: #e85116;
    stroke: #b64011;
  }

  #ies-gauge g.label text {
    text-anchor: middle;
    font-size: 14px;
    font-weight: bold;
    fill: #666;
  }
</style>